function FilterMenuListItem(name, value) {
    this.name = name;
    this.value = value;
}

export default FilterMenuListItem;
